import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'voip-peers-search',
  templateUrl: './voip-peers-search.component.html',
  styleUrls: ['./voip-peers-search.component.scss']
})
export class VoipPeersSearchComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<VoipPeersSearchComponent>,
              @Inject(MAT_DIALOG_DATA) public search: any) { }

  onApply = new EventEmitter();

  ngOnInit(): void {
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.dialogRef.close();
    this.onApply.emit(this.search);
  }

}
